export default __webpack_public_path__ + "static/media/security_down_time.c35b2729.svg";